import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup, Input, Checkbox } from "@cofano/cck";
import { Grid } from "@mui/material";
import { Language } from "imports/Utils";

export default ({ control }) => {
	return (
		<Grid xs={6} item>
			<h4 style={{ marginTop: 0 }}>{Language("LETTER_OF_PROTEST_MISSING_DOCUMENTS")}</h4>

			<FormGroup label={Language("LETTER_OF_PROTEST_MISSING_DOCUMENTS")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.missingDocumentsApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_MISSING_DOCUMENTS")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.missingDocuments"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<h4>{Language("LETTER_OF_PROTEST_RESAMPLING_DUE_TO")}</h4>

			<div style={{ padding: 16 }}>
				<div style={{ marginBottom: 8 }}>
					<Controller
						name="protestVariables.resamplingApplicable"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_RESAMPLING_AVAILABLE")} />} />
				</div>

				<div style={{ marginBottom: 8 }}>
					<Controller
						name="protestVariables.dueToIncomplete"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_DUE_TO_INCOMPLETE")} />} />
				</div>

				<div style={{ marginBottom: 8 }}>
					<Controller
						name="protestVariables.dueToIncorrect"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_DUE_TO_INCORRECT")} />} />
				</div>

				<Controller
					name="protestVariables.dueToOutOfSpec"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_DUE_TO_OUT_OF_SPEC")} />} />
			</div>

			<FormGroup label={Language("LETTER_OF_PROTEST_FAILURE_PRESENT_BARGE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.failurePresentBargeApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<h4>{Language("LETTER_OF_PROTEST_TERMINAL_NOT_READY")}</h4>

			<FormGroup label={Language("LETTER_OF_PROTEST_TERMINAL_NOT_READY")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.terminalNotReadyApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_TERMINAL_NOT_READY_RECEIVE_DELIVER")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.terminalNotReadyReceiveDeliver"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_TERMINAL_NOT_READY_UNTIL_TIME")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.terminalNotReadyUntilTime"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_TERMINAL_NOT_READY_UNTIL_DATE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.terminalNotReadyUntilDate"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup
				label={(
					<React.Fragment>
						{Language("LETTER_OF_PROTEST_TENDERED_NOTICE")}
						{" "}
						{Language("LETTER_OF_PROTEST_OR")}
						{" "}
						{Language("LETTER_OF_PROTEST_WAS_READY_TO")}
					</React.Fragment>
				)}
				overflow="hidden">
				<div style={{ padding: 16 }}>
					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.tenderedNoticeApplicable"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_TENDERED_NOTICE")} />} />
					</div>

					<Controller
						name="protestVariables.wasReadyTo"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_WAS_READY_TO")} />} />
				</div>
			</FormGroup>

			<h4>{Language("LETTER_OF_PROTEST_WAS_READY_TO_LOAD_DISCHARGE")}</h4>

			<FormGroup label={Language("LETTER_OF_PROTEST_WAS_READY_TO_LOAD_DISCHARGE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.wasReadyToLoadDischarge"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_WAS_READY_TO_TIME")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.wasReadyToAtTime"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_WAS_READY_TO_DATE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.wasReadyToAtDate"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SLOW")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.slowRateApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SLOW_RATE_SHIP")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.slowRateShipApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SLOW_RATE_SHORE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.slowRateShoreApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SLOW_RATE_SHORE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.slowRateRequestApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_SLOW_RATE_REQUEST")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.slowRateRequest"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_MAXIMUM_TRANSFER_RATE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.maximumTransferRate"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_AVERAGE_TRANSFER_RATE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.avgDischargeRate"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_TOTAL_TRANSFER_RATE")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.totalDischargeTime"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_OPERATION_DELAYS")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.operationDelaysApplicable"
					control={control}
					render={({ field }) => <Checkbox {...field} checked={field.value} />} />
			</FormGroup>

			<FormGroup
				label={(
					<React.Fragment>
						{Language("LETTER_OF_PROTEST_OPERATION_DELAYS_DUE_SHIP")}
						{" "}
						{Language("LETTER_OF_PROTEST_OR")}
						{" "}
						{Language("LETTER_OF_PROTEST_OPERATION_DELAYS_DUE_SHORE")}
					</React.Fragment>
				)}
				overflow="hidden">
				<div style={{ paddingLeft: 16, paddingTop: 16 }}>
					<div style={{ marginBottom: 8 }}>
						<Controller
							name="protestVariables.operationDelaysDueToShip"
							control={control}
							render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_OPERATION_DELAYS_DUE_SHIP")} />} />
					</div>

					<Controller
						name="protestVariables.operationDelaysDueToShore"
						control={control}
						render={({ field }) => <Checkbox {...field} checked={field.value} label={Language("LETTER_OF_PROTEST_OPERATION_DELAYS_DUE_SHORE")} />} />
				</div>
			</FormGroup>

			<FormGroup label={Language("LETTER_OF_PROTEST_OPERATION_DELAYS_NOTES")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="protestVariables.operationDelayNotes"
					control={control}
					render={({ field }) => <Input {...field} />} />
			</FormGroup>
		</Grid>
	);
};

